<template>
  <div id="softwaresList">
    <div>
      <softwares-import @upload-success="filter" />
    </div>

    <div>
      <grid id="softwaresGrid"
            :title="$t('a-softwares:softwares')"
            :columns="columns"
            :paginated-dto="softwares"
            :pagination="false"
            :download-btn="false"
            @load="filter"
      >
        <template slot="date" slot-scope="props">{{ props.dto.date | date }}</template>

        <template slot="size" slot-scope="props">{{ props.dto.size | octet }}</template>

        <div slot="actions" slot-scope="props" :data-software-id="props.dto.id" class="text-right">
          <i :id="'deleteSoftware-' + props.dto.id" class="icon-trash" @click="confirmDeleteSoftware(props.dto)" />
        </div>
      </grid>

      <confirm id="deleteSoftware"
               v-model="showDeleteSoftwareConfirm"
               :message="$t('a-softwares:confirmDelete', { software: softwareToDelete.name })"
               @confirm:validate="deleteSoftware"
      />
    </div>
  </div>
</template>

<script>
import to from '@/modules/await-to-js'
import eventBus from '@/modules/eventBus'

import SoftwaresImport from './SoftwaresImport'

export default {
  titleKey: 'administrationSoftwares',

  components: { SoftwaresImport },

  data () {
    return {
      // list
      softwares: {},
      showDeleteSoftwareConfirm: false,
      softwareToDelete: {}
    }
  },

  computed: {
    columns () {
      return [
        { text: this.$t('a-softwares:name'), id: 'name' },
        { text: this.$t('a-softwares:date'), slot: 'date' },
        { text: this.$t('a-softwares:size'), slot: 'size' },
        { slot: 'actions' }
      ]
    }
  },

  created () {
    this.filter()
  },

  methods: {
    async filter (options = {}) {
      // There is no filter for now but maybe in the future...

      // Get filtered data
      this.getSoftwares()
    },

    async getSoftwares () {
      let error, response
      [error, response] = await to(this.$api.getSoftwares(this.$store.getters.application))
      if (error || !response) return

      // the Grid component is waiting for a PagiatedDto => tranform the list response to a PaginatedDto
      this.softwares = {
        list: response.data,
        page: 1,
        nbPages: 1,
        count: response.data.length,
        totalCount: response.data.length,
        pageSize: response.data.length
      }
    },

    confirmDeleteSoftware (software) {
      this.showDeleteSoftwareConfirm = true
      this.softwareToDelete = software
    },

    async deleteSoftware () {
      let error
      [error] = await to(this.$api.deleteSoftware(this.$store.getters.application, this.softwareToDelete.name))
      if (error) return

      // Success
      eventBus.$emit('message-success', this.$t('a-softwares:deleteSuccess', { software: this.softwareToDelete.name }))
      // Refresh list
      this.filter()
    }
  }
}
</script>
